/**
 * Error Reporting Service
 * Stub for error tracking integration (Sentry, Bugsnag, etc.)
 */

interface ErrorReportingOptions {
  tags?: Record<string, unknown>;
  extra?: Record<string, unknown>;
}

interface UserInfo {
  id: string;
  username: string;
  email: string;
  role: string;
}

class ErrorReportingService {
  captureException(error: unknown, options?: ErrorReportingOptions): void {
    // In production, this would send to Sentry/Bugsnag/etc.
    if (process.env.NODE_ENV === 'development') {
      console.error('[ErrorReporting]', error, options);
    }
  }

  captureMessage(message: string, options?: ErrorReportingOptions): void {
    if (process.env.NODE_ENV === 'development') {
      console.warn('[ErrorReporting]', message, options);
    }
  }

  setUser(user: UserInfo): void {
    // Set user context for error reports
    if (process.env.NODE_ENV === 'development') {
      console.debug('[ErrorReporting] User set:', user.username);
    }
  }

  clearUser(): void {
    // Clear user context
  }
}

export const errorReporting = new ErrorReportingService();
export default errorReporting;
